import type {APITask} from '../types/api-task'
import type {BaseTask} from '../types/task'
import {DOTCOM_CHAT_AGENT_SLUG} from './constants'
import {copilotFeatureFlags} from '@github-ui/copilot-feature-flags'

export type QuickChatTask = Pick<APITask, 'agent_collaborators'> | Pick<BaseTask, 'agentSlug' | 'taskType'>

/**
 * Detail payloads identify legacy quick chats by collaborator slug. Merged list
 * tasks also carry the authoritative type from the dedicated chat query because
 * chat tasks may use the CLI collaborator slug.
 */
export function isQuickChatTask(task: QuickChatTask | null | undefined): boolean {
  if (!task) return false
  return (
    ('agent_collaborators' in task && task.agent_collaborators?.some(({slug}) => slug === DOTCOM_CHAT_AGENT_SLUG)) ||
    ('agentSlug' in task && (task.agentSlug === DOTCOM_CHAT_AGENT_SLUG || task.taskType === 'chat'))
  )
}

export function isQuickChatTaskViewEnabled(): boolean {
  return copilotFeatureFlags.quickChatTaskViewEnabled
}
